// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    CirclePoundSterling,
    CirclePower,
    CircleQuestionMark,
    CircleSlash,
    CircleSlash2,
    CircleSmall,
    CircleStar,
    CircleStop,
    CircleUser,
    CircleUserRound,
    CircleX,
    CircuitBoard,
    Citrus,
    Clapperboard,
    Clipboard,
    ClipboardCheck,
    ClipboardClock,
    ClipboardCopy,
    ClipboardList,
    ClipboardMinus,
    ClipboardPaste,
    ClipboardPen,
    ClipboardPenLine,
    ClipboardPlus,
    ClipboardType,
    ClipboardX,
    Clock,
    Clock1,
    Clock10,
    Clock11,
    Clock12,
    Clock2,
    Clock3,
    Clock4,
    Clock5,
    Clock6,
    Clock7,
    Clock8,
    Clock9,
    ClockAlert,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "circle-pound-sterling" through "clock-alert", inclusive. */
const shard: Record<string, LucideIcon> = {
    "circle-pound-sterling": CirclePoundSterling,
    "circle-power": CirclePower,
    "circle-question-mark": CircleQuestionMark,
    "circle-slash": CircleSlash,
    "circle-slash-2": CircleSlash2,
    "circle-small": CircleSmall,
    "circle-star": CircleStar,
    "circle-stop": CircleStop,
    "circle-user": CircleUser,
    "circle-user-round": CircleUserRound,
    "circle-x": CircleX,
    "circuit-board": CircuitBoard,
    citrus: Citrus,
    clapperboard: Clapperboard,
    clipboard: Clipboard,
    "clipboard-check": ClipboardCheck,
    "clipboard-clock": ClipboardClock,
    "clipboard-copy": ClipboardCopy,
    "clipboard-list": ClipboardList,
    "clipboard-minus": ClipboardMinus,
    "clipboard-paste": ClipboardPaste,
    "clipboard-pen": ClipboardPen,
    "clipboard-pen-line": ClipboardPenLine,
    "clipboard-plus": ClipboardPlus,
    "clipboard-type": ClipboardType,
    "clipboard-x": ClipboardX,
    clock: Clock,
    "clock-1": Clock1,
    "clock-10": Clock10,
    "clock-11": Clock11,
    "clock-12": Clock12,
    "clock-2": Clock2,
    "clock-3": Clock3,
    "clock-4": Clock4,
    "clock-5": Clock5,
    "clock-6": Clock6,
    "clock-7": Clock7,
    "clock-8": Clock8,
    "clock-9": Clock9,
    "clock-alert": ClockAlert,
};

export default shard;
